var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enterprise-container"},[_c('Banner',{staticClass:"enterprise-banner-contaoner",attrs:{"mode":'enterprise-center'}}),_c('RightsCard',{staticClass:"enterprise-right-card-container",attrs:{"deptVal":_vm.dept,"tokenVal":_vm.token}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }